import { LoadBreakout } from "./LoadBreakout";

export class MoveScheduleDispatchLoads {
	sourceDispatchId: number = 0;
	sourceDispatchLoadCount: number = 0;
	destinationScheduleId: number = 0;
	destinationLoadCount: number = 0;
	internalComments: string = '';
	rate: number = 0;
	rateUom: string = '';
	NewLoads: LoadBreakout[] = [];
	OriginalLoads: LoadBreakout[] = [];
	unloadNumber: string = '';
	loadNumber: string = '';
} 